import { AxiosResponse } from 'axios'
import { RequestCDU, RequestREAD } from 'services/Instances'

export const CreParamsServices = () => {
  const path = 'ParametrizacaoCre'

  const create = async (requestObj: any): Promise<AxiosResponse> =>
    await RequestCDU.post(`${path}/Create`, requestObj)

  const patch = async (requestObj: ICreParams): Promise<AxiosResponse> =>
    await RequestCDU.patch(`${path}/Update`, requestObj)

  const get = async (): Promise<AxiosResponse<ICreParams>> =>
    await RequestREAD.get(`${path}`)

  const getParametrizacaoCRE = async (): Promise<
    AxiosResponse<ParametrizacaoCREResponse[]>
  > => await RequestREAD.get(`${path}`)

  return { create, get, getParametrizacaoCRE, patch }
}

export interface ParametrizacaoCREResponse {
  idParametrizacaoCre: number
  qtdDiasSlaDocMensal: number
  qtdDiasSlaPendenciaCre: number
  dsDiaInicioFechamentoAnexoDoc: string
  dsDiaFimFechamentoAnexoDoc: string
  qtdMesesAnaliseCarteiraAntiga: number
  dsMascaraNumCre: string
}

export interface ICreParams {
  idParametrizacaoCre?: number
  qtdDiasSlaDocMensal: number | string
  qtdDiasSlaPendenciaCre: number | string
  dsDiaInicioFechamentoAnexoDoc: string
  dsDiaFimFechamentoAnexoDoc: string
  qtdMesesAnaliseCarteiraAntiga: number | string
  dsMascaraNumCre: string
}
